// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"6d43071c","153":"125101e9","466":"4f2fce02","496":"3f068bfd","639":"2310fb7a"}[chunkId] + ".chunk.js";
};